<template>
  <q-page class="container" padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold self-end">
        Cadastrar Banco de Dados
      </p>
    </div>

    <q-card>
      <q-card-section>
        <q-form ref="myForm" @submit.prevent="onSubmit">
          <div class="row col-12 q-col-gutter-sm">
            <div class="col-md-2 col-sm-12 col-xs-12">
              BD ID:
              <q-input
                dense
                outlined
                v-model="bancoDados.bancoDadosId"
                label="Cliente ID"
                :rules="[
                  (val) => (val && val.length > 0) || 'Campo Obrigatório',
                ]"
              >
                <template v-slot:prepend>
                  <q-icon name="storage" />
                </template>
              </q-input>
            </div>

            <div class="col-md-2 col-sm-12 col-xs-12">
              BD HOST:
              <q-input
                dense
                outlined
                v-model="bancoDados.host"
                label="Host"
                :rules="[
                  (val) => (val && val.length > 0) || 'Campo Obrigatório',
                ]"
              >
                <template v-slot:prepend>
                  <q-icon name="storage" />
                </template>
              </q-input>
            </div>

            <div class="col-md-2 col-sm-12 col-xs-12">
              BD PORT:
              <q-input
                dense
                outlined
                v-model="bancoDados.port"
                label="Port"
                :rules="[
                  (val) => (val && val.length > 0) || 'Campo Obrigatório',
                ]"
              >
                <template v-slot:prepend>
                  <q-icon name="storage" />
                </template>
              </q-input>
            </div>

            <div class="col-md-2 col-sm-12 col-xs-12">
              USER:
              <q-input
                dense
                outlined
                v-model="bancoDados.user"
                label="USER"
                :rules="[
                  (val) => (val && val.length > 0) || 'Campo Obrigatório',
                ]"
              >
                <template v-slot:prepend>
                  <q-icon name="person" />
                </template>
              </q-input>
            </div>

            <div class="col-md-2 col-sm-12 col-xs-12">
              PASSWORD:
              <q-input
                dense
                outlined
                v-model="bancoDados.pass"
                label="Password"
                :type="text"
                :rules="[
                  (val) => (val && val.length > 0) || 'Campo Obrigatório',
                ]"
              ></q-input>
            </div>

            <div class="col-md-1 col-sm-12 col-xs-12">
              <p></p>
              <q-btn
                class="q-mt-sm full-width"
                color="positive"
                label="Criar"
                type="submit"
                no-caps
                icon="add"
                v-on:click="criar()"
              />
            </div>
          </div>
        </q-form>
      </q-card-section>
    </q-card>

    <q-card class="q-mt-md">
      <div class="q-pa-md">
        <q-table
          dense
          title="Listagem de Bancos"
          :rows="listaBancos"
          :columns="columns"
          @request="atualizarTabela"
          :loading="loading"
          :filter="filter"
          class="tabela-tamanho-fixo"
          row-key="bancoDadosId"
        >
          <template v-slot:body="props">
            <q-tr :props="props">
              <q-td class="text-left" key="bancoDadosId" :props="props">
                {{ props.row.bancoDadosId }}
              </q-td>
              <q-td class="text-left" key="host" :props="props">
                {{ props.row.host }}
              </q-td>
              <q-td class="text-left" key="port" :props="props">
                {{ props.row.port }}
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </q-card>
  </q-page>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

export default {
  name: "CriarEntradaBD",
  setup() {
    const $q = useQuasar();
    const myForm = ref(null);
    const bancoDados = ref({
      bancoDadosId: "",
      host: "",
      port: "",
      user: "",
      pass: "",
    });

    const loading = ref(true);
    const listaBancos = ref([]);

    const columns = [
      {
        name: "bancoDadosId",
        label: "bancoDadosId",
        field: "bancoDadosId",
        align: "left",
      },
      { name: "host", label: "HOST", field: "host", align: "left" },
      { name: "port", label: "PORT", field: "port", align: "left" },
    ];

    const store = useStore();

    let listarBancos = async () => {
      try {
        let resposta = await store.dispatch("office/listarBanco");
        listaBancos.value = resposta.listaBancos;
        loading.value = false;
      } catch (error) {
        console.error(error);
      }
    };

    onMounted(() => {
      listarBancos();
    });

    let criar = async () => {
      let sucess = await myForm.value.validate();
      if (!sucess) {
        return;
      }

      try {
        await store.dispatch("office/criarBanco", {
          bancoDadosId: bancoDados.value.bancoDadosId,
          host: bancoDados.value.host,
          port: bancoDados.value.port,
          user: bancoDados.value.user,
          pass: bancoDados.value.pass,
        });

        $q.notify({
          message: "Banco de Dados Cadastrado!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        reset();
        onReset();
      } catch (e) {
        if (e.request.status < 500) {
          for (let index in e.response.data.erros) {
            $q.notify({
              message: e.response.data.erros[index],
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        }

        if (e.request.status >= 500) {
          $q.notify({
            message: "Erro no servidor, tente novamente",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const onReset = async () => {
      await reset();
      myForm.value.resetValidation();
    };

    const reset = async () => {
      bancoDados.value = {};
    };

    return {
      bancoDados,
      criar,
      myForm,
      columns,
      listaBancos,
      filter: ref(""),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
